// src/slices/branchesSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserSignUpStatus } from '../schemas/types/shared';

interface UserSignUpStatusState {
  status: UserSignUpStatus | null;
}

const initialState: UserSignUpStatusState = {
  status: null
};

const UserSignUpStatusSlice = createSlice({
  name: 'signingUpUser',
  initialState,
  reducers: {
    setStatus: (
      state: UserSignUpStatusState,
      action: PayloadAction<UserSignUpStatus>
    ) => {
      state.status = action.payload;
    },
    clearStatus: (state: UserSignUpStatusState) => {
      state.status = null;
    }
  }
});

export const { setStatus, clearStatus } = UserSignUpStatusSlice.actions;
export default UserSignUpStatusSlice.reducer;
